import {
  USQCPPage,
  UKQCPPage,
  ReferralPage,
  AgentReferralPage,
  QuestionnairePage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
  ExplanationPage,
  CombinedPaymentPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "../packs/components/DevTools";
import Autofill from "../packs/components/Autofill";
import SkipToQcp from "../packs/components/SkipToQcp";
import ViewTraces from "../packs/components/ViewTraces";
import EnvHealth from "../packs/components/EnvHealth";

export const pageComponents = {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  ExplanationPage,
  CombinedPaymentPage,
};

export const utilityComponents = {
  DevTools,
  Autofill,
  SkipToQcp,
  ViewTraces,
  EnvHealth,
};
